import { createAsyncThunk } from "@reduxjs/toolkit";
import { TestimonyServices } from "Services/axios/Testimony.service";
import { toast } from "react-toastify";
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchTestimony = createAsyncThunk(
	"Testimony/fetchTestimony",
	async (filters) => {
		try {
			const response = await TestimonyServices.getAll(filters);
			return response.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const submitTestimony = createAsyncThunk(
	"Testimony/submitTestimony",
	async (data) => {
		try {
			const formData = new FormData();
			formData.append("user_id", data.user_id);
			data.membership_id && formData.append("membership_id", data.membership_id);
			formData.append("review", data.review);
			formData.append("star_rating", data.star_rating);
			formData.append("additional_info", data.additional_info);
			formData.append("show_in_home", data.show_in_home);

			let response;
			if (data.isUpdate) {
				response = await TestimonyServices.update(data.id, formData);
				toast.success("Testimony berhasil diperbarui", {
					position: toast.POSITION.TOP_RIGHT,
				});
			} else {
				response = await TestimonyServices.create(formData);
				toast.success("Testimony berhasil ditambahkan", {
					position: toast.POSITION.TOP_RIGHT,
				});
			}
			data.successCallback && data.successCallback();
			return response.data.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);


export const handleEditTestimony = (dispatch, data, setField) => {
	for (const key in data) {
		if (data.hasOwnProperty(key)) {
			dispatch(setField({ field: key, value: data[key] }));
		}
		dispatch(setField({ field: "isUpdate", value: true }));
	}
}

export const deleteTestimony = createAsyncThunk(
	"Testimony/deleteTestimony",
	async (id) => {
		try {
			const response = await TestimonyServices.delete(id);
			toast.success("Testimony berhasil dihapus", {
				position: toast.POSITION.TOP_RIGHT,
			});
			return response.data.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const attachDetachTestimonyMainProgram = createAsyncThunk(
	"Testimony/attachDetachMainProgram",
	async (data) => {
		const formData = new FormData();
		data.data.forEach((element) => {
			formData.append("main_program[]", element.value);
		});
		try {
			const response = await TestimonyServices.attachDetachMainProgram(
				data.id,
				formData
			);
			return response.data.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);
